module.exports = fox._r("fonts/ropasoftpro-extrabolditalic-webfont.svg", __webpack_public_path__ + "fonts/ropasoftpro-extrabolditalic-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-extrabolditalic-webfont.svg
// module id = 960
// module chunks = 4